import React, { useState } from 'react';
import { __ } from '../../translations';
import { Text, FlexWrapper } from '@intigral/shared';
import { Modal } from '@intigral/ui';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import LikeDislikeButton from './LikeDislikeButton';

interface LikeDislikePopupProps {
    itemGuid?: string;
    item?: any;
    closeLikeDislikePopup?: (open: boolean) => void;
}

const LikeDislikePopup: React.FC<LikeDislikePopupProps> = ({ itemGuid, item, closeLikeDislikePopup }) => {
    const [open, setOpen] = useState(true);

    const closePopup = (open: boolean) => {
        setOpen(false);
        closeLikeDislikePopup(open);
    };

    return (
        <div className="container">
            {/* <Button onClick={closePopup}>Show Movie Opinion</Button> */}
            <Modal open={open} onOpenChange={closePopup} widthSet="fullPage" theme="black" closePlacement="start">
                <FlexWrapper flexDirection="column" gap="2x" valign>
                    <Text as="h4" variant="h4" margin="2x" size={{ default: '20', md: '20' }}>
                        {__('rate_movie')}
                    </Text>
                    <FlexChild alignSelf="center">
                        <LikeDislikeButton itemGuid={itemGuid} item={item} handleLikeDislikePopupClose={closePopup} />
                    </FlexChild>
                </FlexWrapper>
            </Modal>
        </div>
    );
};
export default LikeDislikePopup;
